

































import CreateFeedContainerFilePreview from './CreateFeedContainerFilePreview.vue';

import { FeedStateModule } from '@/store';
import { TagModel } from '@/type/api';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ContentService } from '@/kuroco_api';
import truncate from 'lodash/truncate';
import { PostFileHelper, util } from '@/util';
import { POSTING_STATUS } from './CreateFeedContainer.vue';

@Component<CreateFeedContainerFiles>({
  components: {
    CreateFeedContainerFilePreview,
  },
})
export default class CreateFeedContainerFiles extends Vue {
  // PROPS
  @Prop({
    type: Array,
    required: true,
  })
  renderSource!: PostFileHelper['renderSource'];
  @Prop({
    type: String,
    required: true,
  })
  mediaType!: PostFileHelper['mediaType'];
  @Prop({
    type: Array,
    required: true,
  })
  imageRotationStyles!: [];
  @Prop({
    type: Boolean,
    required: true,
  })
  vimeo!: boolean;
  @Prop({
    type: String,
    required: true,
  })
  postingState!: POSTING_STATUS;

  // MUTATIONS
  get wrapperStyle() {
    const hidden = {
      marginTop: '-100px',
      paddingTop: '0px',
    };
    if (this.vimeo && this.postingState === POSTING_STATUS.LOADING) {
      return hidden;
    }
    if (this.vimeo) {
      return {
        paddingTop: this.vimeoElm ? `${this.vimeoElm.clientHeight}px` : '260px',
      };
    }

    return {};
  }

  // FIELDS
  vimeoElm: Element | null = null;
  POSTING_STATUS = POSTING_STATUS;
}

export interface CreateFeedContainerFilesInput {
  helper: PostFileHelper;
}

enum ELEMENT_TYPE {
  NONE,
  IMAGE,
  VIDEO_VIMEO,
  VIDEO,
}
